/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { Route } from '@angular/router';
import { AuthGuard } from './auth-guard';
import { ImportScheduleComponent } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/tools/import-schedule';
import { AnnotationSettingsComponent } from 'libs/sysque/toolbelt/feature/src/lib/components/workspace/annotation-settings';
import { ConfigurationLocationComponent } from 'libs/sysque/toolbelt/feature/src/lib/components/workspace/configuration-location';
import { SystemManagerComponent } from 'libs/sysque/toolbelt/feature/src/lib/components/system-manager/system-manager.component';
import { ElectricalSettingsComponent } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/tools/electrical-settings';
import { ConvertOptionsComponent } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/workspace/convert-options';
import { ApplyPanelDataComponent } from 'libs/sysque/toolbelt/feature/src/lib/components/detailing/apply-panel-data';
import { DeleteSystemCategoryComponent } from 'libs/sysque/toolbelt/feature/src/lib/delete-system-category';
import { CableTrayFamilyInformation } from 'libs/sysque/toolbelt/feature/src/lib/components/add-family-information/cable-tray-family-information';
import { ConduitFamilyInformation } from 'libs/sysque/toolbelt/feature/src/lib/components/add-family-information/conduit-family-information';
import { FieldFabFamilyInformation } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/field-fab-family-information';
import { JunctionBoxFamilyInformation } from 'libs/sysque/toolbelt/feature/src/lib/components/add-family-information/junction-box-family-information';
import { AppShellComponent } from 'libs/sysque/toolbelt/feature/src/lib/app-shell';
import { AboutDialogComponent } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/workspace/about-dialog';
import { ApplyIdComponent } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/detailing/apply-id';
import { AddFittingPopupComponent } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-fitting-popup';
import { SysqueSystemCategoryOptionsComponent } from 'libs/sysque/toolbelt/feature/src/lib/sysque-system-category-options';
import { PopupRoutingComponent } from 'libs/sysque/toolbelt/feature/src/lib/popup-routing/popup-routing.component';
import { NoAccessComponent } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/no-access';
import { ProjectDataComponent } from 'libs/sysque/toolbelt/feature/src/lib/components/add-family-information/project-data';
import { ImportSystemsComponent } from 'libs/sysque/toolbelt/feature/src/lib/components/import-systems/import-systems.component';
import { AssignProjectParameterValuesComponent } from 'libs/sysque/toolbelt/feature/src/lib/components/assign-project-parameter-values/assign-project-parameter-values.component';
import { AddProjectParameterComponent } from 'libs/sysque/toolbelt/feature/src/lib/components/add-project-parameter/add-project-parameter.component';
import { FittingPrioritizationComponent } from 'libs/sysque/toolbelt/feature/src/lib/components/fitting-prioritization/fitting-prioritization.component';
import { HandAndMachineBendFamilyInformation } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/hand-and-machine-bend-family-information';
import { LineGraphicsComponent } from 'libs/sysque/toolbelt/feature/src/lib/components/add-family-information/line-graphics';
import { SysqueGaugeComponent } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/workspace/sysque-gauge';
import { CreateServiceTypeComponent } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/create-service-type';
import { DeleteServiceTypeComponent } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/delete-service-type';
import { KickHandAndMachineBendFamilyInformation } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/kick-hand-and-machine-bend-family-information';
import { UserCustomContentFamilyInformation } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/user-custom-content-family-information';
import { DeviceEquipmentFamilyInformation } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/device-equipment-family-information/device-equipment-family-information.component';
import { HangerSpecificationFamilyInformation } from '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/hanger-specification-family-information';
import { SysqueGaugeTakeOffServiceComponent } from 'libs/sysque/toolbelt/feature/src/lib/components/category-scope/sysque-gauge-take-off-service/sysque-gauge-take-off-service.component';

export const appRoutes: Route[] = [
  {
    path: '',
    component: AppShellComponent,
    loadChildren: () =>
      import('../../../../libs/sysque/toolbelt/feature/src/lib/app-shell/app-shell.module').then(
        (m) => m.AppShellModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/about-dialog',
    component: AboutDialogComponent,
    loadChildren: () =>
      import('../../../../libs/sysque/toolbelt/feature/src/lib/components/workspace/about-dialog').then(
        (m) => m.AboutDialogModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/import-schedule-dialog',
    component: ImportScheduleComponent,
    loadChildren: () =>
      import('../../../../libs/sysque/toolbelt/feature/src/lib/components/tools/import-schedule').then(
        (m) => m.ImportScheduleModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/annotation-settings-dialog',
    component: AnnotationSettingsComponent,
    loadChildren: () =>
      import('../../../../libs/sysque/toolbelt/feature/src/lib/components/workspace/annotation-settings').then(
        (m) => m.AnnotationSettingsModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/configuration-location-dialog',
    component: ConfigurationLocationComponent,
    loadChildren: () =>
      import('../../../../libs/sysque/toolbelt/feature/src/lib/components/workspace/configuration-location').then(
        (m) => m.ConfigurationLocationModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/system-manager-dialog',
    component: SystemManagerComponent,
    loadChildren: () =>
      import('../../../../libs/sysque/toolbelt/feature/src/lib/components/system-manager').then(
        (m) => m.SystemManagerModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/electrical-settings-dialog',
    component: ElectricalSettingsComponent,
    loadChildren: () =>
      import('../../../../libs/sysque/toolbelt/feature/src/lib/components/tools/electrical-settings').then(
        (m) => m.ElectricalSettingsModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/place-coupling-dialog',
    component: ConvertOptionsComponent,
    data: { componentTitle: 'Place Couplings' },
    loadChildren: () =>
      import('../../../../libs/sysque/toolbelt/feature/src/lib/components/workspace/convert-options').then(
        (m) => m.ConvertOptionsModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/convert-system-dialog',
    component: ConvertOptionsComponent,
    data: { componentTitle: 'Convert System' },
    loadChildren: () =>
      import('../../../../libs/sysque/toolbelt/feature/src/lib/components/workspace/convert-options').then(
        (m) => m.ConvertOptionsModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/apply-conduit-id',
    component: ApplyIdComponent,
    data: { isConduitIdDialog: true },
    loadChildren: () =>
      import('../../../../libs/sysque/toolbelt/feature/src/lib/components/detailing/apply-id').then(
        (m) => m.ApplyIdModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/apply-equipment-device-id',
    component: ApplyIdComponent,
    data: { isConduitIdDialog: false },
    loadChildren: () =>
      import('../../../../libs/sysque/toolbelt/feature/src/lib/components/detailing/apply-id').then(
        (m) => m.ApplyIdModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/apply-panel-data-dialog',
    component: ApplyPanelDataComponent,
    loadChildren: () =>
      import('../../../../libs/sysque/toolbelt/feature/src/lib/components/detailing/apply-panel-data').then(
        (m) => m.ApplyPanelDataModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/add-fitting',
    component: AddFittingPopupComponent,
    loadChildren: () =>
      import('../../../../libs/sysque/toolbelt/feature/src/lib/components/add-fitting-popup').then(
        (m) => m.AddFittingPopupModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/create-system-dialog',
    component: SysqueSystemCategoryOptionsComponent,
    data: { isCreateDialog: true, isSystemOperation: true, isDuplicateOperation: false },
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/sysque-system-category-options/sysque-system-category-options.module'
      ).then((m) => m.SysqueSystemCategoryOptionsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/rename-system-dialog',
    component: SysqueSystemCategoryOptionsComponent,
    data: { isCreateDialog: false, isSystemOperation: true, isDuplicateOperation: false },
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/sysque-system-category-options/sysque-system-category-options.module'
      ).then((m) => m.SysqueSystemCategoryOptionsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/create-category-dialog',
    component: SysqueSystemCategoryOptionsComponent,
    data: { isCreateDialog: true, isSystemOperation: false, isDuplicateOperation: false },
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/sysque-system-category-options/sysque-system-category-options.module'
      ).then((m) => m.SysqueSystemCategoryOptionsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/rename-category-dialog',
    component: SysqueSystemCategoryOptionsComponent,
    data: { isCreateDialog: false, isSystemOperation: false, isDuplicateOperation: false },
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/sysque-system-category-options/sysque-system-category-options.module'
      ).then((m) => m.SysqueSystemCategoryOptionsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/duplicate-system-dialog',
    component: SysqueSystemCategoryOptionsComponent,
    data: { isCreateDialog: false, isSystemOperation: false, isDuplicateOperation: true },
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/sysque-system-category-options/sysque-system-category-options.module'
      ).then((m) => m.SysqueSystemCategoryOptionsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/delete-system-dialog',
    component: DeleteSystemCategoryComponent,
    data: { isSystemOperation: true },
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/delete-system-category/delete-system-category.module'
      ).then((m) => m.DeleteSystemCategoryModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/delete-category-dialog',
    component: DeleteSystemCategoryComponent,
    data: { isSystemOperation: false },
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/delete-system-category/delete-system-category.module'
      ).then((m) => m.DeleteSystemCategoryModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/cable-tray-family-information-dialog',
    component: CableTrayFamilyInformation,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/cable-tray-family-information'
      ).then((m) => m.CableTrayFamilyInformationModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/conduit-family-information-dialog',
    component: ConduitFamilyInformation,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/conduit-family-information'
      ).then((m) => m.ConduitFamilyInformationModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/junction-box-family-information-dialog',
    component: JunctionBoxFamilyInformation,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/junction-box-family-information/junction-box-family-information.module'
      ).then((m) => m.JunctionBoxFamilyInformationModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/field-fab-family-information-dialog',
    component: FieldFabFamilyInformation,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/field-fab-family-information'
      ).then((m) => m.FieldFabFamilyInformationModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/hand-and-machine-bend-family-information-dialog',
    component: HandAndMachineBendFamilyInformation,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/hand-and-machine-bend-family-information'
      ).then((m) => m.HandAndMachineBendFamilyInformationModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/kick-hand-and-machine-bend-family-information-dialog',
    component: KickHandAndMachineBendFamilyInformation,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/kick-hand-and-machine-bend-family-information'
      ).then((m) => m.KickHandAndMachineBendFamilyInformationModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/user-custom-content-family-information-dialog',
    component: UserCustomContentFamilyInformation,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/user-custom-content-family-information'
      ).then((m) => m.UserCustomContentFamilyInformationModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/device-equipment-family-information-dialog',
    component: DeviceEquipmentFamilyInformation,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/device-equipment-family-information'
      ).then((m) => m.DeviceEquipmentFamilyInformationModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/hanger-specification-family-information-dialog',
    component: HangerSpecificationFamilyInformation,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/hanger-specification-family-information'
      ).then((m) => m.HangerSpecificationFamilyInformationModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/create-service-type-dialog',
    component: CreateServiceTypeComponent,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/create-service-type'
      ).then((m) => m.CreateServiceTypeModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/delete-service-type-dialog',
    component: DeleteServiceTypeComponent,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/delete-service-type'
      ).then((m) => m.DeleteServiceTypeModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/line-graphics-dialog',
    component: LineGraphicsComponent,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/line-graphics'
      ).then((m) => m.LineGraphicsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/project-data-dialog',
    component: ProjectDataComponent,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-family-information/project-data'
      ).then((m) => m.ProjectDataModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/import-systems-dialog',
    component: ImportSystemsComponent,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/import-systems'
      ).then((m) => m.ImportSystemsModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/assign-project-data',
    component: AssignProjectParameterValuesComponent,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/assign-project-parameter-values'
      ).then((m) => m.AssignProjectParameterValuesModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/add-new-project-parameter',
    component: AddProjectParameterComponent,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/add-project-parameter'
      ).then((m) => m.AddProjectParameterModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/fitting-prioritization-dialog',
    component: FittingPrioritizationComponent,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/fitting-prioritization'
      ).then((m) => m.FittingPrioritizationModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'dialog/sysque-gauge-dialog',
    component: SysqueGaugeComponent,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/workspace/sysque-gauge'
      ).then((m) => m.SysqueGaugeModule),
    canActivate: [AuthGuard],
  },

  {
    path: 'dialog/sysque-gauge-takeoff-dialog',
    component: SysqueGaugeTakeOffServiceComponent,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/category-scope/sysque-gauge-take-off-service/sysque-gauge-take-off-service.module'
      ).then((m) => m.SysqueGaugeTakeOffServiceModule),
    canActivate: [AuthGuard],
  },
  
  {
    path: 'dialog/:dialog-name',
    component: PopupRoutingComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'no-access',
    component: NoAccessComponent,
    loadChildren: () =>
      import(
        '../../../../libs/sysque/toolbelt/feature/src/lib/components/no-access'
      ).then((m) => m.NoAccessModule)
  },

  {
    path: '**',
    component: AppShellComponent,
    canActivate: [AuthGuard],
  },
];